import { useKimLhc } from '@/context/KimLhc';

import { useUpdateKimLhcReport } from '@/hooks/useUpdateKimLhcReport';

interface BaseStepParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
}

export const useStepMutation = <T extends BaseStepParams>() => {
	const { onNextStep, currentStep } = useKimLhc();
	const { mutateAsync, isLoading } = useUpdateKimLhcReport();

	const mutate = async (params: T): Promise<void> => {
		await mutateAsync({ ...params, step: currentStep + 1 });
		onNextStep();
	};

	return { mutate, isLoading };
};
